import React from 'react';

const PrivacyPage: React.FC = () => (
  <div className="min-h-screen bg-black text-white p-6 max-w-3xl mx-auto">
    <h1 className="text-3xl font-bold text-gold mb-4">Política de Privacidade</h1>
    <p className="mb-4">Esta página descreve como suas informações são coletadas, usadas e protegidas no Anuário AMS.</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Coleta de Informações</h2>
    <p>Coletamos apenas informações necessárias para exibir o anuário, como nomes, fotos e depoimentos dos participantes. Nenhum dado sensível é armazenado ou compartilhado com terceiros.</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Uso das Informações</h2>
    <p>As informações são usadas exclusivamente para fins de apresentação do anuário digital. Não utilizamos dados para publicidade ou venda.</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Proteção de Dados</h2>
    <p>Adotamos medidas de segurança para proteger os dados dos participantes. Caso deseje remover ou alterar alguma informação, entre em contato com a organização do anuário.</p>
    <h2 className="text-xl font-bold text-gold mt-6 mb-2">Contato</h2>
    <p>Para dúvidas sobre privacidade, envie um e-mail para anuario@ams.com.</p>
  </div>
);

export default PrivacyPage;
